import { render, staticRenderFns } from "./top-event-countries-card.vue?vue&type=template&id=72580824&scoped=true&"
import script from "./top-event-countries-card.vue?vue&type=script&lang=js&"
export * from "./top-event-countries-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72580824",
  null
  
)

export default component.exports